// src/pages/Accounting/Receipts/components/Dashboard/index.tsx

import { useMemo, useState } from "react";
import type { FilterKey, Receipt } from "../../types";
import { filterReceipts, countByMatchStatus } from "../../utils";
import { VelaLede } from "./VelaLede";
import { FilterChips } from "./FilterChips";
import { ReceiptsList } from "./ReceiptsList";

interface DashboardProps {
  receipts: Receipt[];
  categoriesById?: Record<string, string>;
  onRowClick: (id: string) => void;
  onReviewClick: () => void;
}

export function Dashboard({
  receipts,
  categoriesById = {},
  onRowClick,
  onReviewClick,
}: DashboardProps) {
  const [filter, setFilter] = useState<FilterKey>("all");
  const [search, setSearch] = useState("");

  const totalCount = receipts.length;
  const matchedCount = countByMatchStatus(receipts, "matched");
  const needsReviewCount = countByMatchStatus(receipts, "needs-review");

  const visible = useMemo(() => {
    const byStatus = filterReceipts(receipts, filter);
    const q = search.trim().toLowerCase();
    if (!q) return byStatus;
    return byStatus.filter(
      (r) =>
        r.vendorName.toLowerCase().includes(q) ||
        (categoriesById[r.id]?.toLowerCase() ?? "").includes(q),
    );
  }, [receipts, filter, search, categoriesById]);

  return (
    <div>
      <VelaLede
        totalCount={totalCount}
        matchedCount={matchedCount}
        needsReviewCount={needsReviewCount}
        onReviewClick={onReviewClick}
      />
      <FilterChips
        receipts={receipts}
        activeFilter={filter}
        onFilterChange={setFilter}
        searchQuery={search}
        onSearchChange={setSearch}
      />
      <ReceiptsList
        receipts={visible}
        categoriesById={categoriesById}
        onRowClick={onRowClick}
      />
    </div>
  );
}